export const PostsData: any[] = [
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class=""user"" href=""/people/1454"">@Michael_VandenHeuvel</a>  DSG built a separate daycare building at their corporate HQ to run a daycare for employees.   The process started a few years ago during covid, but we were recently made aware that it is in operation.  Its run exclusively by a third party, but we would like to add a positive coverage grant instead of remaining silent.   I pulled my manuscript form used for XSGL on Sheetz as a template.  I have attached and the state of domicile is PA.  <a href=""/content/329187"">SEXUAL ABUSE OR MOLESTATION COVERAGE.docx</a> </p>
<p><a class=""user"" href=""/people/139"">@Christopher_Cappelli</a>  This was mentioned in the original referral, but here is a separate post for the actual endt.  The exposure and controls is all within the Roadmap.  HelpDesk suggested to clear cookies in your internet search engine to see the Roadmap, if not, I will send seperately.</p>
<p>Thanks Eric   </p>
<p><a class=""user"" href=""/people/302"">@Paul_Kimball</a></p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Need to task Legal COE; ok with the form assuming you want defense expenses to reduce the limits of insurance</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>N/A</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Ok if this version of the endorsement meets the structure you want for the coverage.  Are you looking to provide coverage only for that one location and exclusion for everywhere else? <a href="/content/329512">MS 377467 SEXUAL ABUSE OR MOLESTATION COVERAGE.docx</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Brian,</p>
<p>I am referring this specific exposure for DSG.  DSG has 3rd run a daycare center at their Corporate HQ.  We are looking to provide affirmative coverage for this exposure.  This is consistent with our expiring position.  There have been no SHAM claims to date.</p>
<p>We are only looking to provide this coverage for this specific location.</p>
<p><br />Regards,<br /><br />Chris</p>
<p><br /><a class=""user"" href=""/people/327"">@Brian_Ford</a> <a class=""user"" href=""/people/346"">@Eric_Johnson</a> <a class=""user"" href=""/people/241"">@Lisa_Jarmicki</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Eric - it is my understanding you want this for one location only - please provide the name/address of said location so we can add it to the form.</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Please see edits attached based on the responses (Eric please remember to not use comments in legal drafting threads): </p>
<p><a href=""/content/330197"">DSG.MVH Edits.MS 377467 SEXUAL ABUSE OR MOLESTATION COVERAGE.docx</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>The attached accepts the redlines.  <a href="/content/330214">MS 377467 SEXUAL ABUSE OR MOLESTATION COVERAGE 12.28.docx</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class="user" href="/people/36">@Kathleen_George</a>  FYI will be adding.</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class=""user"" href=""/people/139"">@Christopher_Cappelli</a> <a class=""user"" href=""/people/1454"">@Michael_VandenHeuvel</a>   There was pushback received on the concept of the endt from AON, as they now see this as an exclusion at all their retail locations.  Limited exposure at retail level and no claims.   Can we either change the endt to include all locations or remain silent?  Thanks Eric </p>
<p><a class=""user"" href=""/people/302"">@Paul_Kimball</a> <a class=""user"" href=""/people/241"">@Lisa_Jarmicki</a>    </p>"
`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>So they are viewing this endorsement as only for one location (which it would be, since we only scheduled their single HQ location), or they want the exclusion to apply to all locations? </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class="user" href="/people/1454">@Michael_VandenHeuvel</a> Viewing the endt as coverage for the one location or corporate headquarters, but also viewing the endt as an exclusion for all other retail locations for abuse.  Preference would be to have endt to provide abuse coverage for all locations.  If not feasible, not have any endt regarding abuse and remain silent for all locations.  This was the position the past few years.   Eric</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>ok so confirming you want coverage for all locations; edits below:</p>
<p><a href=""/content/330947"">MS 377467 SEXUAL ABUSE OR MOLESTATION COVERAGE 01.02.docx</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class="user" href="/people/139">@Christopher_Cappelli</a>  If you could let me know, if changing to all locations for DSG abuse coverage, would be ok?  I'd like to include the wording in the binder.   thanks</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Reposting from comments (please remember to not use comments in legal drafting threads): </p>
<div id=""comment-177087"" class=""list-group-item comment"" style=""box-sizing: border-box; display: block; padding: 0px; margin: 0px 0px 0.75rem; background-color: #fafafa; border-width: 0px; border-top-left-radius: 0.1875rem; border-top-right-radius: 0.1875rem; color: #383838; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 16px; text-align: left; white-space: normal;"" data-parent-entity=""post"" data-parent-id=""216459"" data-comment-id=""177087"">
<div class=""media"" style=""box-sizing: border-box; display: flex; align-items: flex-start; white-space: normal;""><a style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" title=""Cappelli, Christopher"" href=""https://crm-collaboration.chubb.com/people/139""><img class=""img-32 avatar mr-2"" style=""box-sizing: border-box; vertical-align: middle; border-style: none; width: 2rem; height: 2rem; flex: 0 0 auto; border-radius: 50%; margin-right: 0.5rem;"" src=""https://crm-collaboration.chubb.com/people/139/avatar-64.jpg?v=0678c17"" alt="""" /></a>
<div class=""media-body"" style=""box-sizing: border-box; flex: 1 1 0%; word-break: break-word; line-height: 1.5; min-width: 0px; font-size: 0.875rem;"">
<div class=""comment-body"" style=""box-sizing: border-box;""><a style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" href=""https://crm-collaboration.chubb.com/people/139"">Cappelli, Christopher</a>
<p style=""box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;"">Just because we provide affirmative coverage for one location doesnt mean we are excluding this from the rest of the program.  It just means we are not specifically addressing it</p>
<p style=""box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;""><a class=""user"" style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" href=""https://crm-collaboration.chubb.com/people/346"">@Eric_Johnson</a> <a class=""user"" style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" href=""https://crm-collaboration.chubb.com/people/1454"">@Michael_VandenHeuvel</a> </p>
</div>
<div class=""text-muted"" style=""box-sizing: border-box; color: #8c8c8c;""><time style=""box-sizing: border-box;"" title=""1/5/2024 8:09 AM"" datetime=""2024-01-05T13:09:35Z"">01/05/2024 08:09 AM</time> </div>
</div>
<div class=""media-icons"" style=""box-sizing: border-box; display: flex; flex: 0 0 auto; margin: -0.25rem;""> </div>
</div>
</div>
<div id=""comment-177090"" class=""list-group-item comment"" style=""box-sizing: border-box; display: block; padding: 0px; margin: 0px 0px 0.75rem; background-color: #fafafa; border-width: 0px; border-bottom-right-radius: 0.1875rem; border-bottom-left-radius: 0.1875rem; color: #383838; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; font-size: 16px; text-align: left; white-space: normal;"" data-parent-entity=""post"" data-parent-id=""216459"" data-comment-id=""177090"">
<div class=""media"" style=""box-sizing: border-box; display: flex; align-items: flex-start; white-space: normal;""><a style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" title=""Johnson, Eric C"" href=""https://crm-collaboration.chubb.com/people/346""><img class=""img-32 avatar mr-2"" style=""box-sizing: border-box; vertical-align: middle; border-style: none; width: 2rem; height: 2rem; flex: 0 0 auto; border-radius: 50%; margin-right: 0.5rem;"" src=""https://crm-collaboration.chubb.com/people/346/avatar-64.jpg?v=5941eb6"" alt="""" /></a>
<div class=""media-body"" style=""box-sizing: border-box; flex: 1 1 0%; word-break: break-word; line-height: 1.5; min-width: 0px; font-size: 0.875rem;"">
<div class=""comment-body"" style=""box-sizing: border-box;""><a style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" href=""https://crm-collaboration.chubb.com/people/346"">Johnson, Eric C</a>
<p style=""box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem;""><a class=""user"" style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" href=""https://crm-collaboration.chubb.com/people/139"">@Christopher_Cappelli</a> <a class=""user"" style=""box-sizing: border-box; color: #1c8fc4; text-decoration-line: none;"" href=""https://crm-collaboration.chubb.com/people/1454"">@Michael_VandenHeuvel</a>  Maybe I mis-interpreting the wording, but wouldn't part A of the endt remove the potential of coverage (silent)?</p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt; text-align: justify; font-size: 11pt; font-family: Calibri, sans-serif;""><strong style=""box-sizing: border-box; font-weight: bolder;""><span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif;"">Schedule:         Dick’s Sporting Goods Corporate HQ</span></strong></p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt; text-align: justify; font-size: 11pt; font-family: Calibri, sans-serif;""><strong style=""box-sizing: border-box; font-weight: bolder;""><span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif;"">                              345 Court Street</span></strong></p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt; text-align: justify; font-size: 11pt; font-family: Calibri, sans-serif;""><strong style=""box-sizing: border-box; font-weight: bolder;""><span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif;"">                              Coraopolis, PA 15108</span></strong></p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt; text-align: justify; font-size: 11pt; font-family: Calibri, sans-serif;""><strong style=""box-sizing: border-box; font-weight: bolder;""><span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif;""> </span></strong></p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt; text-align: justify; font-size: 11pt; font-family: Calibri, sans-serif;""><span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif;"">Solely for the location in the Schedule above, this policy is amended as follows with respect to “sexual abuse or molestation” “claims” for which damages are sought under this policy:</span></p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt 0.25in; text-align: justify; text-indent: -0.25in; font-size: 11pt; font-family: Calibri, sans-serif;""><strong style=""box-sizing: border-box; font-weight: bolder;""><span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif; color: black;"">A.</span></strong>   <span style=""box-sizing: border-box; font-size: 10pt; font-family: Georgia, serif; color: black;"">This policy does not provide coverage for “claims” arising out of “Sexual Abuse or Molestation” other than as provided in this endorsement.</span></p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt 0.25in; text-align: justify; text-indent: -0.25in; font-size: 11pt; font-family: Calibri, sans-serif;""> </p>
<p style=""box-sizing: border-box; margin: 0in 0in 6pt 0.25in; text-align: justify; text-indent: -0.25in; font-size: 11pt; font-family: Calibri, sans-serif;""><span style=""color: #000000; font-family: Georgia, serif;""><span style=""font-size: 13.3333px;"">I am  not sure  which draft you are referring to, but if we only schedule the one location, the language as drafted in the original draft would limit coverage to the scheduled location.</span></span></p>
</div>
</div>
</div>
</div>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Mike - thank you for posting the comments.   </p>
<p>By adding the ""solely to"" language - as we have discussed in the past - we are leaving certain questions open to interpretation.  </p>
<p>First - by addressing SHAM specifically - even just for one location - there is an argument that we are covering SHAM claims for all other locations because we are not technically ""remaining silent"" with regard to SHAM on the policy as a whole.  Particularly since the last paragraph of the endorsement states that other than the coverage provided within the endorsement, all other SHAM is excluded.  Again, arguably, this is still limited to the one location.  </p>
<p>Ultimately, by creating any ambiguity, the endorsement would likely be interpreted against Chubb so we could have to provide SHAM coverage for all other locations.  If that is the intent, then there would be no need to change the language.  If we want to preserve the ability to argue SHAM is excluded in any way we should limit the coverage section to just the one location and have the exclusion apply to everything else. </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Thanks Lisa. Chris just let us know how you want to proceed.</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class="user" href="/people/139">@Christopher_Cappelli</a>  If that is the case and per my email, I'd like to release the binder without any endt as it relates to abuse?    AON saw the endt and don't agree with its intent or more specifically believe its removing our silent position on all other locations.  To remain silent on all other locations (retail) is more important than the daycare positive coverage grant for one daycare location (corporate HQ daycare).  Especially considering the corporate daycare already has coverage provided thru the third party vendor's insurance.    Please advise quickly, as I have delayed sending the binder.   Eric </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class="user" href="/people/139">@Christopher_Cappelli</a>  Per my teams and my below post from Friday, I'm releasing my binder without any endt as it relates to Abuse.  Broker has been requesting a binder for some time and followed up again today.  Thanks Eric </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class="user" href="/people/139">@Christopher_Cappelli</a>  Following up on DSG abuse and my post from Monday the 8th on our options?  Thanks Eric     <a class="user" href="/people/163">@Jason_A_Clark</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class=""user"" href=""/people/139"">@Christopher_Cappelli</a>  </p>
<ul>
<li>In force/quoted:  No endt or exclusion on the program as it relates to abuse for any and all locations.</li>
<li>AON ask:  Follow 'In force' and quoted renewal by remaining silent on all locations including daycare.  They would also be happy with a positive grant for abuse, but no exclusions or remain silent for any other locations.  Retro date would need addressed too, as program has always been silent back to 2001.  </li>
<li>My recommendation:   Provide an abuse endt providing abuse coverage for the corporate daycare only.  Retro date would need addressed. This endt needs to remain completely silent and no exclusions, as it relates to abuse on all other DSG locations.  </li>
</ul>
<p>Please advise, tks</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p><a class=""user"" href=""/people/241"">@Lisa_Jarmicki</a> <a class=""user"" href=""/people/1454"">@Michael_VandenHeuvel</a>  Attached is the latest redlined version of the Abuse endt.  <a class=""user"" href=""/people/139"">@Christopher_Cappelli</a> and my approach would be provide Abuse cover at the corporate daycare only, but remove any reference to other locations or remain silent on all other retail locations.  AON pushed back on the original endt.  Please advise if wording and intention makes sense?  tks  <a href=""/content/333905"">MS 377467 SEXUAL ABUSE OR MOLESTATION COVERAGE 1.11.docx</a> </p>
<p> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Ok with the language as it matches intent, but note that this could be interpreted as providing coverage for other locations since we are removing the exclusion and by addressing SHAM even at one location, we are not technically remaining silent, as Lisa noted in her post on 1/5.</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>BF, AON is pushing back on our endorsement wording for SHAM.  The ask is to remove Part A of the Manuscript and only address SHAM at 1 specific location (the daycare) Since we are not technically remaining silent on their store operations there could be ambiguity in coverage and indirectly provide SHAM coverage for all locations (indirectly)</p>
<p>Are you OK with this?  There have been no SHAM claims (to my knowledge) at retail stores.</p>
<p><a class=""user"" href=""/people/327"">@Brian_Ford</a> </p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  },
  {
    "id": "9f4ebad3-efbe-47fc-8942-6b18d955386f",
    "user": {
      "email": "manojkumar.rejinthala@chubb.com",
      "name": "Manoj Rejinthala",
      "atMention": "@ManojKumar_Rejinthala",
      "profileImage": "fa fa-user"
    },
    "date": "2024-09-27T13:20:25.214Z",
    "message": `<p>Confirming based on BF's comment we will remain silent this year. Canceling task for myself and Lisa.</p>`,
    "style": null,
    "numberOfLikes": 0,
    "currentUserLiked": false,
    "edited": false,
    "numberOfComments": 0,
    "comments": []
  }
];

export const FileTypesDeleteMapper: any = {
  "docx": "Document",
  "pptx": "Presentation",
  "xlsx": "Spreadsheet",
  "note": "Note",
  "folder": "Folder",
  "txt": "Text",
  "pdf": "PDF"
};